import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Receipt } from "lucide-react";
import { getMyTransactions } from "@/lib/api";
import { KIND_FILTERS, amountText, creditText, filterTransactions, kindLabel, normalizeTransactions, statusLabel } from "@/lib/transactions";

const when = (iso) => { try { return new Date(iso).toLocaleString("id-ID", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return "-"; } };

export default function MyTransactions() {
  const [state, setState] = useState({ status: "loading", rows: [] });
  const [kind, setKind] = useState("");
  useEffect(() => {
    let alive = true;
    getMyTransactions(100).then((p) => { if (alive) setState({ status: "ready", rows: normalizeTransactions(p) }); })
      .catch(() => { if (alive) setState({ status: "error", rows: [] }); });
    return () => { alive = false; };
  }, []);
  const rows = filterTransactions(state.rows, kind);
  return (
    <div className="mx-auto max-w-4xl px-4 py-6" data-testid="my-transactions">
      <div className="flex items-center gap-2"><Receipt className="h-6 w-6 text-slate-700" /><h1 className="text-xl font-semibold text-slate-900">Transaksi Saya</h1></div>
      <p className="mt-1 text-sm text-slate-600">Pembelian paket dan pergerakan kredit akun Anda. Pesanan yang masih menunggu belum menambah saldo. Butuh bantuan? <Link to="/bantuan" className="text-blue-700 underline">Pusat Bantuan</Link>.</p>
      <label className="mt-4 block text-sm">Jenis
        <select className="ml-2 rounded border border-slate-200 bg-white px-2 py-1" value={kind} onChange={(e) => setKind(e.target.value)} data-testid="tx-filter">
          {KIND_FILTERS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></label>
      {state.status === "loading" && <p className="mt-4 flex items-center gap-2 text-sm text-slate-500" data-testid="tx-loading"><Loader2 className="h-4 w-4 animate-spin" /> Memuat…</p>}
      {state.status === "error" && <p className="mt-4 text-sm text-amber-800" role="alert" data-testid="tx-error">Transaksi tidak dapat dimuat saat ini. Saldo dan riwayat Anda tidak berubah.</p>}
      {state.status === "ready" && rows.length === 0 && <p className="mt-4 text-sm text-slate-500" data-testid="tx-empty">{state.rows.length === 0 ? "Belum ada transaksi." : "Tidak ada transaksi untuk jenis ini."}</p>}
      {rows.length > 0 && (
        <ul className="mt-4 divide-y divide-slate-100 rounded-lg border border-slate-200 bg-white" data-testid="tx-list">
          {rows.map((r) => (
            <li key={r.id} className="flex flex-wrap items-center justify-between gap-2 p-3" data-testid={`tx-${r.id}`}>
              <div className="min-w-0"><p className="text-sm font-medium text-slate-900">{kindLabel(r.kind)}</p>
                {r.description && <p className="truncate text-xs text-slate-500">{r.description}</p>}<p className="text-xs text-slate-400">{when(r.at)}</p></div>
              <div className="text-right"><p className="text-sm text-slate-900" data-testid="tx-credits">{creditText(r)}</p>
                {amountText(r) && <p className="text-xs text-slate-500">{amountText(r)}</p>}<p className="text-xs text-slate-500" data-testid="tx-status">{statusLabel(r.status)}</p></div>
            </li>))}
        </ul>)}
    </div>
  );
}
